import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import { Control } from '../../_models/control';
import { ControlService } from '../../_services/control.service';
import { ListaService } from '../../_services/lista.service';
import { ListaItem } from '../../_models/lista-item';

@Component( {
  selector: 'app-control-editar',
  templateUrl: 'control-editar.component.html'
} )

export class ControlEditarComponent implements OnInit {

  carInformacionInicial = true;
  codExiste = false;
  guardando = false;
  control: Control;
  lisControles: Control[] = [];
  formulario: FormGroup;
  submitted = false;
  lisCausales: SelectItem[] = [];

  constructor( private conControlesServicio: ControlService,
               private route: ActivatedRoute,
               private fb: FormBuilder,
               private location: Location,
               private lisServicio: ListaService,
               private conServicio: ConfirmationService,
               private navServicio: NavService ) {
  }

  ngOnInit(): void {

    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        this.conControlesServicio.obtenerPorId( params[ 'id' ] ).subscribe( control => {
          this.control = control;
          this.carServiciosIniciales();

        } );
      } else {
        this.conControlesServicio.listado().subscribe( controles => {
          this.lisControles = controles;
          this.carServiciosIniciales();
        } );
      }
    } );
  }

  carServiciosIniciales() {
    this.formulario = this.fb.group( {
      idControl: [ this.control ? this.control.idControl : null ],
      codigo: [ this.control ? this.control.codigo : null, [ Validators.required, Validators.maxLength( 20 ) ] ],
      nombre: [ this.control ? this.control.nombre : null, [ Validators.required, Validators.maxLength( 50 ) ] ],
      descripcion: [ this.control ? this.control.descripcion : null, [ Validators.maxLength( 500 ) ] ],
      url: [ this.control ? this.control.url : null, this.control ? (!this.control.indicadorInterno ? [ Validators.required, Validators.maxLength( 500 ) ] : []) : [] ],
      idCausal: [ this.control ? this.control.idCausal : null ],
      indicadorInterno: [ this.control ? this.control.indicadorInterno : null, [ Validators.required ] ],
      indicadorHabilitado: [ this.control ? this.control.indicadorHabilitado : true ],
      indicadorIntegracion: [ this.control ? this.control.indicadorIntegracion : true ],
      indicadorRequiereAdjunto: [ this.control ? this.control.indicadorRequiereAdjunto : false ],
      auditoriaUsuario: [ this.control ? this.control.auditoriaUsuario : null ],
      auditoriaFecha: [ this.control ? this.control.auditoriaFecha : null ],
    } );


    this.lisServicio.getMasterDetails( 'ListasCausalesSolicitudes' ).subscribe( causales => {
      causales.map( ( s: ListaItem ) => {
        this.lisCausales.push( { label: s.nombre, value: s.idLista } );
      } );
      this.carInformacionInicial = false;
    } );


  }

  onSubmit() {
    this.submitted = true;
    if ( !this.codExiste && this.formulario.valid ) {
      this.guardando = true;
      const control = this.formulario.value;
      if ( control.idControl ) {
        this.conControlesServicio.actualizar( control ).subscribe( rta => {
          this.navServicio.setMesage( 2 );
          this.guardando = false;
          this.location.back();
        }, error => {
          this.navServicio.setMesage( 3 );
          this.guardando = false;
        } );
      } else {
        this.conControlesServicio.crear( control ).subscribe( rta => {
          control.idControl = rta.idControl;
          this.f.idControl.setValue( rta.idControl );
          this.navServicio.setMesage( 1 );
          this.guardando = false;
          this.location.back();
        }, error => {
          this.navServicio.setMesage( 3 );
          this.guardando = false;
        } );
      }
    }
  }


  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      } );
    } else {
      this.location.back();
    }
  }

  validarCodigo() {
    this.codExiste = this.lisControles.find( x => x.codigo === this.f.codigo.value ) ? true : false;
  }

  get f() {
    return this.formulario.controls;
  }

  cambioComportamiento() {
    this.f.url.clearValidators();
    if ( !this.f.indicadorInterno.value ) {
      this.f.url.setValidators( [ Validators.required, Validators.maxLength( 500 ) ] );
    } else {
      this.f.url.setValue( null );
      this.f.url.setValidators( [] );
    }
  }

}
